import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div(({ theme }) => ({
    padding: theme.spacing.large,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const Header = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.small,
}));

export const Content = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));

export const TnCItem = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xSmall,
}));
